if (!customElements.get('logo-slider-large')) {
  class LogoSliderLarge extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      this.settings = {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
      };

      if (this.hasAttribute('js-autoplay')) {
        this.settings['autoplay'] = {
          delay: this.getAttribute('js-autoplay'),
        };
      }

      const swiper = new Swiper(this.querySelector('.swiper'), this.settings);
    }
  }

  customElements.define('logo-slider-large', LogoSliderLarge);
}
